<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-12">
            <!-- <yt-fw-dropdown
                [ModelName]="'jezik'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]='true'
                [Required]='true'
                [Disabled]='false'
                formControlName="JezikID"
                name="cmbJezik"
                [Type]="ID"
                [ngClass]="{'is-invalid': submitted && fc.JezikID.invalid}"
                [Label]="'OSOBAZNAJEZIK.JEZIK.SINGULAR'">
            </yt-fw-dropdown> -->
            <yt-dropdown-picklist
                [ModelName]="'jezik'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="JezikID"
                [Label]="'OSOBAZNAJEZIK.JEZIK.SINGULAR'"
            >
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.JezikID.invalid">
                <span *ngFor="let validation of errorMessages.JezikID">
                    <span class="error-message" *ngIf="fc.JezikID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
</form>